import React from 'react';
import FWorkbenchFilterBar, { FWorkbenchFilterField } from '../core/FWorkbenchFilterBar';
import { ComboRow } from '../core/coremodels';
import activityProgrammeLanguage from './activityprogramme.language';

interface Props {
  costcenter: string;
  axis: string;
  status: string;
  costcenters: ComboRow[];
  axes: ComboRow[];
  statuses: ComboRow[];
  onCostcenterChange: (code: string) => void;
  onAxisChange: (code: string) => void;
  onStatusChange: (code: string) => void;
  onRefresh: () => void;
  onClear: () => void;
  loading?: boolean;
}

export default class ActivityProgrammeFilterBar extends React.PureComponent<Props> {
  private onChange = (name: string, value: string) => {
    if (name === 'costcenter') this.props.onCostcenterChange(value);
    if (name === 'axis') this.props.onAxisChange(value);
    if (name === 'status') this.props.onStatusChange(value);
  };

  render() {
    const fields: FWorkbenchFilterField[] = [
      { name: 'costcenter', label: 'Cost Center', items: this.props.costcenters, width: 4 },
      { name: 'axis', label: 'Strategic Axis', items: this.props.axes, width: 4 },
      { name: 'status', label: 'Plan State', items: this.props.statuses, width: 4 },
    ];

    return (
      <FWorkbenchFilterBar
        title={activityProgrammeLanguage.filtersTitle}
        subtitle={activityProgrammeLanguage.filtersSubtitle}
        fields={fields}
        values={{ costcenter: this.props.costcenter, axis: this.props.axis, status: this.props.status }}
        onChange={this.onChange}
        onRefresh={this.props.onRefresh}
        onClear={this.props.onClear}
        loading={this.props.loading}
        refreshLabel="Refresh Programme"
        clearLabel="Clear"
      />
    );
  }
}
